import { combineReducers } from "redux";

import authReducer from "./authReducer";
import rightsReducer from "./rightsReducer";

const rootReducer = combineReducers({
  user: authReducer,
  rights: rightsReducer,
});

export default rootReducer;
